var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-product" }, [
    _c("div", { staticClass: "header" }, [
      _c("span", { staticClass: "back", on: { click: _vm.goBack } }, [
        _c("i", {
          staticClass: "iconfont icon-fanhui",
          staticStyle: { "font-size": "24px" },
        }),
      ]),
      _vm._v("\n    创建产品\n  "),
    ]),
    _c("div", { staticClass: "container-wrap" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-steps",
            {
              attrs: {
                direction: "vertical",
                active: _vm.activeStep,
                "finish-status": "success",
              },
            },
            [
              _c("el-step", {
                attrs: { title: "请选择你想创建的产品" },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.activeStep === 0
                                ? "请选择你想创建的产品"
                                : "已选择品类"
                            )
                          ),
                        ]),
                        _vm.activeStep
                          ? _c(
                              "span",
                              {
                                staticClass: "reselect",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleReselect(0)
                                  },
                                },
                              },
                              [_vm._v("重新选择")]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "description",
                    fn: function () {
                      return [
                        _vm.activeStep === 0
                          ? _c("div", [
                              _c("div", { staticClass: "big-type" }, [
                                _c("div", { staticClass: "type-title" }, [
                                  _vm._v("标准类目"),
                                ]),
                                _c(
                                  "ul",
                                  { staticClass: "big-type-list" },
                                  _vm._l(
                                    _vm.productType,
                                    function (item, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          class: [
                                            {
                                              selected:
                                                item.standardCategory ===
                                                _vm.selectedBigType,
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectProductBigType(
                                                item.standardCategory
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.standardCategory)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "small-type" },
                                _vm._l(
                                  _vm.productSmallType,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        attrs: { title: item.category },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "small-type-title" },
                                          [_vm._v(_vm._s(item.category))]
                                        ),
                                        _c(
                                          "ul",
                                          { staticClass: "small-type-list" },
                                          _vm._l(
                                            item.secondClassification,
                                            function (li, i) {
                                              return _c(
                                                "li",
                                                {
                                                  key: i,
                                                  attrs: { title: li.name },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.selectProductSmallType(
                                                        item.category,
                                                        li.name
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: li.icon,
                                                      alt: "",
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(_vm._s(li.name)),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm.activeStep === 1
                          ? _c(
                              "div",
                              { staticClass: "selected-product-type" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.selectedProductType.icon,
                                    alt: "",
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.selectedProductType.name)),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("el-step", {
                attrs: { title: "完善产品信息" },
                scopedSlots: _vm._u([
                  {
                    key: "description",
                    fn: function () {
                      return [
                        _vm.activeStep === 1
                          ? _c("div", { staticClass: "device-type" }, [
                              _c("div", { staticClass: "communicate-title" }, [
                                _c("span", { staticClass: "must" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("设备类型："),
                              ]),
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.deviceTypeData,
                                  function (item, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: index,
                                        class: [
                                          {
                                            selected:
                                              index ===
                                              _vm.selectedDeviceTypeIndex,
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectedDeviceType(
                                              index,
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.deviceTypeMap[item]))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm.activeStep === 1
                          ? _c("div", { staticClass: "device-type" }, [
                              _c("div", { staticClass: "communicate-title" }, [
                                _c("span", { staticClass: "must" }, [
                                  _vm._v("*"),
                                ]),
                                _vm._v("通讯协议："),
                              ]),
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.communicationProtocolData,
                                  function (item, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: index,
                                        class: [
                                          {
                                            selected:
                                              index ===
                                              _vm.selectedCommunicationTypeIndex,
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectedCommunicationType(
                                              index,
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm.activeStep === 1
                          ? _c("div", { staticClass: "communicate-box" }, [
                              _c("div", { staticClass: "not-selected" }, [
                                _c("div", { staticClass: "dms" }, [
                                  _c(
                                    "div",
                                    { staticClass: "communicate-title" },
                                    [
                                      _c("span", { staticClass: "must" }, [
                                        _vm._v("*"),
                                      ]),
                                      _vm._v("配网方式："),
                                    ]
                                  ),
                                  _c(
                                    "ul",
                                    _vm._l(
                                      _vm.dmsMethods,
                                      function (item, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            class: [
                                              {
                                                selected:
                                                  index ===
                                                  _vm.selectedDmsIndex,
                                              },
                                            ],
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectedDmsMethods(
                                                  index,
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item))]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.activeStep === 1
                          ? _c(
                              "div",
                              { staticClass: "product-info" },
                              [
                                _c(
                                  "el-form",
                                  {
                                    ref: "form",
                                    attrs: {
                                      model: _vm.formInfo,
                                      rules: _vm.rules,
                                      "label-width": "80px",
                                      "label-position": "right",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 14 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "custom-form-item",
                                                attrs: {
                                                  label: "客户名称",
                                                  prop: "customerCode",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      placeholder: "请选择客户",
                                                      clearable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.formInfo
                                                          .customerCode,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.formInfo,
                                                          "customerCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "formInfo.customerCode",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.customerData,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.code,
                                                        attrs: {
                                                          label: item.name,
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 14 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "form-item-img",
                                                attrs: {
                                                  label: "产品图片",
                                                  prop: "icon",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "product-img",
                                                  },
                                                  [
                                                    _c(
                                                      "el-upload",
                                                      {
                                                        staticClass:
                                                          "upload-img",
                                                        attrs: {
                                                          action:
                                                            "/admin/sys-file/upload",
                                                          headers: _vm.headers,
                                                          "show-file-list": false,
                                                          "on-success":
                                                            _vm.handleSuccess,
                                                          "on-error":
                                                            _vm.uploadError,
                                                          "before-upload":
                                                            _vm.beforeUpload,
                                                        },
                                                      },
                                                      [
                                                        _vm.formInfo.icon
                                                          ? _c("img", {
                                                              staticClass:
                                                                "uploaded-img",
                                                              attrs: {
                                                                src:
                                                                  _vm.uploadUrl ||
                                                                  _vm.formInfo
                                                                    .icon,
                                                              },
                                                            })
                                                          : _c("div", [
                                                              _c("i", {
                                                                staticClass:
                                                                  "iconfont icon-shangchuantupian",
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "点击上传"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 14 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "custom-form-item",
                                                attrs: {
                                                  label: "产品名称",
                                                  prop: "name",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "品牌+产品名，将在用户App界面上显示",
                                                    maxlength: "64",
                                                    "show-word-limit": "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value: _vm.formInfo.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formInfo,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "formInfo.name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 14 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "custom-form-item",
                                                attrs: {
                                                  label: "产品型号",
                                                  prop: "productModel",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "请输入您的产品型号，多个以;隔开",
                                                    maxlength: "64",
                                                    "show-word-limit": "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formInfo.productModel,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formInfo,
                                                        "productModel",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formInfo.productModel",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 14 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticClass: "custom-form-item",
                                                attrs: {
                                                  label: "产品说明",
                                                  prop: "description",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    placeholder:
                                                      "请输入产品说明，尽可能描述清楚产品型号",
                                                    clearable: "",
                                                    maxlength: "200",
                                                    "show-word-limit": "",
                                                    rows: 4,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formInfo.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formInfo,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formInfo.description",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "btn" },
      [
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "14", disabled: !_vm.isDisabled },
            on: { click: _vm.onSubmit },
          },
          [_vm._v("创建产品")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }